import { Component } from '@angular/core';

/** Site for requesting roles via email **/
@Component({
  selector: 'app-no-role-found.component',
  imports: [],
  templateUrl: './no-role-found.component.html',
  styleUrl: './no-role-found.component.scss',
})
export class NoRoleFoundComponent {}
